import { useRef, useMemo } from 'react';
import { Stack, Box, Card, CardContent } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { DetailView } from './detail-view';
import { DetailPhone } from './detail-phone';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import BackNavigation from 'src/components/ui/headers/title-back';
import PageSection from 'src/layouts/page-section';
import useDeviceView from 'src/hooks/use-device-view';
import { TrackingTable } from './tracking-table';
import { TrackingList } from './tracking-list';


const Page = ({ onNavigate, item }) => {
  const { t } = useTranslation();
  const rootRef = useRef(null);
  const childRef = useRef();
  const { useCompactLayout } = useDeviceView();

  return (
    <PageSection title="Student" rootRef={rootRef}>
      <Stack spacing={1}>
        <BackNavigation
          onBackClick={onNavigate}
          label={t(tokens.nav.students)}
          subLabel={item.code}
        />
        {useCompactLayout ? (
          <Box>
            <DetailPhone
              ref={childRef}
              item={item}
            />
            <TrackingList
              items={item.trackings}
            />
          </Box>
        ) : (
          <Box>
            <DetailView
              ref={childRef}
              item={item}
            />
            <TrackingTable
              items={item.trackings}
            />
          </Box>
        )}
      </Stack>
    </PageSection>
  );
};

export default Page;
